var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import { counterCls, counterCountCls, counterControlCls } from "./Counter.less";
var Counter = /* @__PURE__ */ function(_Component) {
  function Counter2(props) {
    var _this;
    _classCallCheck(this, Counter2);
    _this = _callSuper(this, Counter2, [props]);
    var _this$props = _this.props, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? 0 : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? null : _this$props$max, _this$props$initial = _this$props.initial, initial = _this$props$initial === void 0 ? 0 : _this$props$initial;
    var initialValue = initial;
    if (initial < min) {
      initialValue = min;
    } else if (max !== null && initial > max) {
      initialValue = max;
    }
    _this.state = {
      count: initialValue
    };
    _this.bindMethods();
    return _this;
  }
  __name(Counter2, "Counter");
  _inherits(Counter2, _Component);
  return _createClass(Counter2, [{
    key: "handleIncrement",
    value: /* @__PURE__ */ __name(function handleIncrement() {
      var _this$props2 = this.props, step = _this$props2.step, onIncrement = _this$props2.onIncrement;
      var newCount = this.state.count + step;
      if (this.isInRange(newCount)) {
        this.setState(function() {
          return {
            count: newCount
          };
        });
        if (onIncrement) {
          onIncrement(newCount);
        }
      }
    }, "handleIncrement")
    /**
     * handleDecrement
     */
  }, {
    key: "handleDecrement",
    value: /* @__PURE__ */ __name(function handleDecrement() {
      var _this$props3 = this.props, _this$props3$step = _this$props3.step, step = _this$props3$step === void 0 ? 1 : _this$props3$step, onDecrement = _this$props3.onDecrement;
      var newCount = this.state.count - step;
      if (this.isInRange(newCount)) {
        this.setState(function() {
          return {
            count: newCount
          };
        });
        if (onDecrement) {
          onDecrement(newCount);
        }
      }
    }, "handleDecrement")
    /**
     * isInRange
     *
     * @param {number} count
     * @returns {boolean}
     */
  }, {
    key: "isInRange",
    value: /* @__PURE__ */ __name(function isInRange() {
      var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var _this$props4 = this.props, min = _this$props4.min, max = _this$props4.max;
      return min <= count && (max === null || count <= max);
    }, "isInRange")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleIncrement = this.handleIncrement.bind(this);
      this.handleDecrement = this.handleDecrement.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      return /* @__PURE__ */ React.createElement("div", {
        className: counterCls
      }, /* @__PURE__ */ React.createElement("button", {
        type: "button",
        onClick: this.handleDecrement,
        className: counterControlCls
      }, "-"), /* @__PURE__ */ React.createElement("div", {
        className: counterCountCls
      }, this.state.count), /* @__PURE__ */ React.createElement("button", {
        type: "button",
        onClick: this.handleIncrement,
        className: counterControlCls
      }, "+"));
    }, "render")
  }]);
}(Component);
_defineProperty(Counter, "defaultProps", {
  initial: 0,
  step: 1,
  min: 0,
  max: null,
  onIncrement: null,
  onDecrement: null
});
export {
  Counter
};
